/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useCallback, useEffect } from "react";
import { useCookies } from "react-cookie";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { sendULFEvent, setLoader } from "state/config-slice";
import { initActivation, selectOfferByName, setNeedsRefetching } from "state/offers-slice";

import { AppDispatch } from "state/reducers-combiner";
import { userState } from "state/user-slice";
import Offer from "types/Offer";
import { ULFEvents } from "types/ULF";

const useQueryCallbackHandler = () => {
  const user = useSelector(userState);
  const [searchParams] = useSearchParams();

  const dispatch: AppDispatch = useDispatch();
  const [cookies, setCookie, removeCookie] = useCookies();

  const selectedOffer: Offer = useSelector(selectOfferByName(cookies.OFFER));
  const navigate = useNavigate();
  const error = searchParams.get("error");

  const activationFunction = useCallback(async () => {
    if (!cookies.ACTIVATIONCODE || !selectedOffer || !user.loggedIn) return;

    dispatch(setLoader({ showLoader: true }));

    const storeCookieCode = cookies.ACTIVATIONCODE;

    removeCookie("ACTIVATIONCODE");

    const res = await dispatch(
      initActivation({
        offer: selectedOffer,
        code: storeCookieCode,
      }),
    );

    const errorCode = res?.payload?.response?.data?.status;

    if (errorCode === 409 || errorCode === 404) {
      setCookie("ERRORCODE", errorCode, { path: "/" });
      setCookie("OFFER", res?.payload?.response?.data?.offer, {
        path: "/subscriptionplus",
      });

      setCookie("STATE", errorCode === 409 ? "account_already_exist" : "not_eligible_for_trial", { path: "/" });
    } else if (error === "access_denied" || error === "youtube_partner_error") {
      setCookie("ERROR", error, { path: "/" });
      setCookie("OFFER", res?.payload?.response?.data?.offer, {
        path: "/subscriptionplus",
      });

      setCookie("STATE", error === "access_denied" ? "access_deined" : "youtube_partner_error", { path: "/" });
    } else {
      dispatch(setNeedsRefetching(true));
      navigate("/");
      dispatch(setLoader({ showLoader: true }));
    }

    if (cookies.SUBSCRIPTIONPLUS_TRACKING === "true") {
      dispatch(
        sendULFEvent({
          page: window.location.pathname,
          "event-name": ULFEvents.CALLBACK_ACTIVATION,
          // "offer-name": offerName,
          partner: selectedOffer?.partner,
          source: cookies.SOURCE,
          isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
        }),
      );
    }

    dispatch(setLoader({ showLoader: false, messageHeader: "", messageText: "" }));
  }, [
    dispatch,
    user.loggedIn,
    selectedOffer,
    setCookie,
    removeCookie,
    navigate,
    cookies.SOURCE,
    cookies.SUBSCRIPTIONPLUS_TRACKING,
    cookies.ACTIVATIONCODE,
  ]);

  useEffect(() => {
    activationFunction();
  }, [activationFunction]);

  return;
};

export default useQueryCallbackHandler;
